import styled from "styled-components"
import { COLORS } from "../constants"
import { SelectGamesModal } from "../components"
import { Container } from "reactstrap"
import { NavLink, useLocation } from "react-router-dom"
import { useState } from "react";
import { useSelector } from "react-redux"
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
import { useHistory } from "react-router-dom"
import ReactLoading from "react-loading"
import hamburger from "../assets/images/hamburger.svg"
import close from "../assets/images/close_menu.svg"
import Logo from "../assets/images/logo.png";

const StyledMenu = styled(OffCanvasMenu)`
    background-color: #3290B5;
    height: 100vh;
    z-index:100;
    padding: 20px;
`;
const StyledNav = styled.div`
    height: 70px;
    display: flex;
    align-items: center;
    background-color: ${COLORS.light_blue};
`;
const StyledNavLink = styled(NavLink)`
    border-radius: 10px;
    transition: all 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    border: solid 3px transparent;
    background-color: ${props => props.to.split("/")[1] === props.currentlocation ? `${COLORS.darker_green}` : "none"};
    border: ${props => props.to.split("/")[1] === props.currentlocation ? `solid 3px ${COLORS.green}` : "solid 3px transparent"};

    &:hover{
        background-color: ${COLORS.darker_green};
        border: solid 3px ${COLORS.green};
    }
`;
const StyledButton = styled.button`
    border-radius: 10px;
    transition: all 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    border: solid 3px #e8c92c;
    background-color: #c4a923;
    outline: 0;
    &:focus{
        outline: 0;
        border: solid 3px #e8c92c;
    }

    &:hover{
        background-color: ${COLORS.darker_green};
        border: solid 3px ${COLORS.green};
    }
`;
const StyledCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor};
    width: 60px;
    height: 60px;
    border-radius: 50%;
    color:  ${props => props.color};;
`;
const StyledLogoutButton = styled.button`
    border: 0;
    background: none;
    color: #255466;
    transition: color 0.2s;

    &:hover{
        color: black;
    }
    &:active{
        outline: none;
    }
`;
const StyledBurger = styled.img`
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover{
        opacity: 0.5;
    }
`;
export function NavigationBar(props) {
    const location = useLocation();
    const userRole = useSelector(state => state.auth.userRole);

    const history = useHistory();
    // console.log(userRole)
    const [loading, setLoading] = useState(false)
    const [gamesShown, setGamesShown] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [menuOpened, setMenuOpened] = useState(false);

    const onCloseClick = () => {
        setGamesShown(false)
        setModalVisible(false);
    }
    const logout = () => {
        history.push('/logout')
    }
    return (
        <>
            <OffCanvas
                width={300}
                transitionDuration={300}
                isMenuOpened={menuOpened}
                position={"right"}
                effect={"overlay"}
            >

                <StyledMenu>
                    <div className="text-right mt-1">
                        <StyledBurger src={close} width="25" onClick={() => setMenuOpened(false)} alt="Burger Menu" />
                    </div>
                    <h5 className="text-white">Menu</h5>
                    <ul className="d-flex flex-column list-unstyled mt-3">
                        {userRole === 3 || userRole == 4 &&
                            <li>
                                <StyledButton onClick={() => setModalVisible(true)} className="text-white d-inline-block mt-3" style={{ padding: "1px 7px" }}>
                                    Play
                                    </StyledButton>
                            </li>
                        }
                        <li>
                            <StyledNavLink to="/dashboard" className="text-white d-inline-block mt-3" style={{ padding: "1px 7px" }} currentlocation={location.pathname.split("/")[1]}>
                                My Account
                                </StyledNavLink>
                        </li>
                        <li>
                            <StyledNavLink to="/store" className="text-white d-inline-block mt-3" style={{ padding: "1px 7px" }} currentlocation={location.pathname.split("/")[1]}>
                                T&S Store
                            </StyledNavLink>
                        </li>
                    </ul>
                    <hr className="mt-3 mb-3" />
                    <StyledLogoutButton onClick={logout}>
                        {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Log Out'}
                    </StyledLogoutButton>
                </StyledMenu>

            </OffCanvas>
            <StyledNav>
                <Container className="d-flex flex-row align-items-center justify-content-start">
                    <NavLink to="/dashboard">
                        <img src={Logo} width={180} height={45} alt="Logo" style={{ marginTop: 6 }} />
                    </NavLink>
                    <div className="d-flex d-md-none justify-content-end flex-grow-1">
                        <StyledBurger src={hamburger} width="30" onClick={() => setMenuOpened(true)} alt="Menu" />
                    </div>
                    <div className="align-items-center justify-content-between flex-grow-1 d-none d-md-flex">
                        <ul className="d-flex list-unstyled align-items-center m-0">
                            {userRole == 3 &&
                                <li className="ml-5 mr-3">
                                    <StyledButton onClick={() => setModalVisible(true)} className="text-white d-inline-block" style={{ padding: "1px 7px" }}>
                                        Play
                                    </StyledButton>
                                </li>
                            }
                            <li className="mx-3">
                                <StyledNavLink to="/dashboard" className="text-white d-inline-block" style={{ padding: "1px 7px" }} currentlocation={location.pathname.split("/")[1]}>
                                    My Account
                                </StyledNavLink>
                            </li>
                            <li className="mx-3">
                                <StyledNavLink to="/store" className="text-white d-inline-block" style={{ padding: "1px 7px" }} currentlocation={location.pathname.split("/")[1]}>
                                    T&S Store
                            </StyledNavLink>
                            </li>
                        </ul>
                        <StyledLogoutButton onClick={logout}>
                            {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Log Out'}
                        </StyledLogoutButton>
                    </div>
                </Container>
            </StyledNav>
            {/* Choose Game Modal */}

            <SelectGamesModal games={gamesShown} modalVisible={modalVisible} onClose={onCloseClick} containerheight="72%" isTellFunctionality={true} mode={3} />
        </>
    );
}
